import { create } from 'zustand';
import { LeaveType, LeaveRequest, LeaveBalance } from '../types';

interface HrLeaveState {
  leaveTypes: LeaveType[];
  leaveRequests: LeaveRequest[];
  leaveBalances: LeaveBalance[];
  pendingCount: number;
  totalRequests: number;
  currentPage: number;
  statusFilter: string;
  isLoading: boolean;

  setLeaveTypes: (types: LeaveType[]) => void;
  setLeaveRequests: (requests: LeaveRequest[], total?: number) => void;
  setLeaveBalances: (balances: LeaveBalance[]) => void;
  setPendingCount: (count: number) => void;
  setCurrentPage: (page: number) => void;
  setStatusFilter: (status: string) => void;
  setLoading: (loading: boolean) => void;
}

export const useHrLeaveStore = create<HrLeaveState>((set) => ({
  leaveTypes: [],
  leaveRequests: [],
  leaveBalances: [],
  pendingCount: 0,
  totalRequests: 0,
  currentPage: 0,
  statusFilter: 'PENDING',
  isLoading: false,

  setLeaveTypes: (leaveTypes) => set({ leaveTypes }),
  setLeaveRequests: (leaveRequests, total) =>
    set({ leaveRequests, totalRequests: total ?? leaveRequests.length }),
  setLeaveBalances: (leaveBalances) => set({ leaveBalances }),
  setPendingCount: (pendingCount) => set({ pendingCount }),
  setCurrentPage: (currentPage) => set({ currentPage }),
  setStatusFilter: (statusFilter) => set({ statusFilter }),
  setLoading: (isLoading) => set({ isLoading }),
}));
